import { render, staticRenderFns } from "./SpecialtyDropdownField.vue?vue&type=template&id=75ba8436&"
import script from "./SpecialtyDropdownField.vue?vue&type=script&lang=js&"
export * from "./SpecialtyDropdownField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports